/**
 * Azioni usate nei context delle validazioni Yup
 */
export enum ValidationAction {
  create = 'create',
  edit = 'edit'
}
